import { render, staticRenderFns } from "./InvestmentDetailSection.vue?vue&type=template&id=5af91456&"
import script from "./InvestmentDetailSection.vue?vue&type=script&lang=ts&"
export * from "./InvestmentDetailSection.vue?vue&type=script&lang=ts&"
import style0 from "./InvestmentDetailSection.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports